export default __webpack_public_path__ + "static/faiteLaDiff-a697ef4b8bfddf6463dfd256ebb8bdbc.png";